import { render, staticRenderFns } from "./AdminSpotsOrders.vue?vue&type=template&id=986355b6&scoped=true&"
import script from "./AdminSpotsOrders.vue?vue&type=script&lang=js&"
export * from "./AdminSpotsOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "986355b6",
  null
  
)

export default component.exports